import { Layout } from "antd";

import React from "react";

const { Footer: AntFooter } = Layout;

export const Footer: React.FC = () => {
  return null
};
